import React, { useState, useEffect, useContext } from 'react';
import { marked } from "marked";
import DOMPurify from "dompurify";

const CopyToClipButton = ({ text }) => {

  const copyToClipboard = async (markdownText) => {
    try {
        const rawHtml = marked(markdownText);
        const sanitizedHtml = DOMPurify.sanitize(rawHtml);
        const htmlBlob = new Blob([sanitizedHtml], { type: "text/html" });
        const textBlob = new Blob([markdownText], { type: "text/plain" });

        const data = [new ClipboardItem({ 
            "text/html": htmlBlob, 
            "text/plain": textBlob 
        })];

        await navigator.clipboard.write(data);
        console.log("Formatted Markdown copied to clipboard!");
    } catch (err) {
        console.error("Failed to copy formatted Markdown: ", err);
    }
};

  return (
    <div>
      <button onClick={() => copyToClipboard(text)} 
      className="absolute top-2 right-2 bg-white text-black p-2 rounded hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-400">
      
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 6h12a2 2 0 012 2v12a2 2 0 01-2 2H8a2 2 0 01-2-2V8a2 2 0 012-2z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 6V4a2 2 0 012-2h8a2 2 0 012 2v2" />
        </svg>
      </button>
    </div>
  );
};

export default CopyToClipButton; 


